import { UPDATE_DRAWER_START } from "../../types";

export const update_drawer = (payload) => ({
    type: UPDATE_DRAWER_START,
    payload,
});
